export const brandTheme = {
  brand100: 'rgba(75,197,136,1)',
  brand80: 'rgba(75,197,136,0.8)',
  brand50: 'rgba(75,197,136,0.5)',
  brand20: 'rgba(75,197,136,0.2)',
  brand02: 'rgba(75,197,136,0.02)',
};
